import * as React from 'react';
import ErrorAlert from '../ErrorAlert';

export enum AlertType {
	'Delete',
	'Edit',
}

interface ValidationErrorAlertProps {
	submitError: string | string[] | null;
	alertType: AlertType;
	customMessage?: string | null;
}

function ValidationErrorAlert({ submitError, customMessage, alertType }: ValidationErrorAlertProps) {
	if (!submitError) {
		return null;
	}

	const message = customMessage ?? GetMessageByType(alertType);

	return (
		<ErrorAlert
			message={message}
			error={null} // Validation errors do not need the full error object
		>
			{Array.isArray(submitError) && submitError.length > 0 ? (
				<ul className="validation-error-list">
					{submitError.map((e, index) => (
						<li key={index}>{e}</li>
					))}
				</ul>
			) : typeof submitError === 'string' ? (
				<ul className="validation-error-list">
					<li>{submitError}</li>
				</ul>
			) : null}
		</ErrorAlert>
	);
}

function GetMessageByType(alertType: AlertType): string {
	let message = '';

	if (alertType == AlertType.Edit) {
		message = 'Please check the values you entered below and try again.';
	} else if (alertType == AlertType.Delete) {
		message = 'Error while deleting a record.';
	}

	return message;
}

export default ValidationErrorAlert;
